export const About = (props) => {
  return (
    <div id="about">
      <div className="container" style={{textAlign:'justify'}}>
        <div className="row">
        <div className="about-text">
              <h2>About Us</h2>
              <p>Welcome to <b><strong>RO Service Center Near Me</strong></b>  your one-stop solution for all RO water purifier services. We are a trusted and reliable RO service center near you, dedicated to providing high-quality repair, maintenance, and installation services for all major brands and models of water purifiers. Our team of skilled professionals ensures your RO systems work efficiently, delivering clean, safe, and pure drinking water every day.</p>

              
              
            </div>
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/roabout.png" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            

             
              <p>At <b><strong>RO Service Center Near Me</strong></b>, we understand the importance of <b>pure and healthy drinking water</b> for you and your family. With years of expertise in <b>RO water purifier services</b>, we are committed to offering <b>top-notch solutions</b> to meet your needs. Our certified technicians specialize in diagnosing and resolving all kinds of <b>RO system issues</b>, ensuring smooth and uninterrupted performance.</p>
              <p>We take pride in being the best RO service center near you, offering prompt, affordable, and reliable services to households and businesses. Customer satisfaction is at the heart of what we do, and we go the extra mile to deliver services that exceed expectations.</p>
              {/*
                <p>{props.data ? props.data.paragraph : "loading..."}</p>
              */}
              
            
          </div>
        </div>
      </div>
    </div>
  );
};
